import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#fff",
  viewBox: "0 0 40 41"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M0 .422V40.74h40V.422zm4.444 4.48h31.112V36.26H4.444zM20 9.381V25.06c0 1.265-.967 2.24-2.222 2.24-1.256 0-2.222-.974-2.222-2.24s.966-2.24 2.222-2.24v-4.48c-3.656 0-6.667 3.035-6.667 6.72s3.011 6.72 6.667 6.72 6.666-3.035 6.666-6.72v-8.44c1.37.984 2.799 1.72 4.445 1.72v-4.48c-.105 0-1.639-.49-2.708-1.43s-1.737-2.12-1.737-3.05z" }, null, -1)
  ])))
}
export default { render: render }